import { AUTH, CLOSE_SOCKET, CREATE_SOCKET, FETCH_HISTORIC_MESSAGES, FETCH_HISTORIC_NOTIFICATIONS, FETCH_MORE_HISTORIC_NOTIFICATIONS, GET_CHATS, GET_ONLINE_USERS, LOGOUT, MARK_NOTIFICATIONS_AS_READ, NOTIFICATION_FROM_SOCKET, REPOPULATE, SHOW_NOTIFICATIONS, UPDATE_PROFILE } from '../constants/actionTypes';

const chatReducer = (state = {
    chats: [], 
    onlineUsers: [],
    currentChat: null,
    currentMessagesPage: 0,
    numberOfMessagesPages: 0

}, action) => {

    /*For data related events to chat. Such as messages, chats, users online etc
    */

    switch (action.type) {

        case GET_CHATS:

            return {
                ...state,
                chats: action.data.chats,
                currentPage: action.data.currentChatRoomsPage,
                numberOfPages: action.data.numberOfChatRoomsPages
            }


        case FETCH_HISTORIC_MESSAGES: 

            return {
                ...state,
                currentChat: action.data.chatRoom,
                currentMessagesPage: action.data.currentMessagesPage,
                numberOfMessagesPages: action.data.numberOfMessagesPages
            }
                

        case GET_ONLINE_USERS: 
            //socket should have been closed in actions, remove from state here
            
            return {

                ...state
            }


        //TODO

        default:
            return state; 
    }
}

export default chatReducer; 